import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import NavSidebar from './NavSidebar';
import Sidebar from './Sidebar';
import Header from './Header';
import TitleBar from './TitleBar';
import ImpersonateBanner from '../Admin/ImpersonateBanner';
import FloatingChatWidget from '../Chat/FloatingChatWidget';
import ConnectionMonitorBanner from '../Common/ConnectionMonitorBanner';
import { useSettings } from '../../contexts/SettingsContext';

const Layout = ({ children, activeSection, setActiveSection }) => {
  const [isNavCollapsed, setIsNavCollapsed] = useState(false);
  const { setActiveTab } = useSettings();
  const navigate = useNavigate();

  const handleSectionChange = (section) => {
    setActiveSection(section);
    if (section === 'settings') {
      setActiveTab('user');
    }
    const routes = {
      notes: '/notes',
      calendar: '/calendar',
      'break-reminder': '/break-reminder',
      chat: '/chat',
      settings: '/settings',
      profile: '/profile',
      admin: '/admin',
    };
    navigate(routes[section] || '/notes');
  };

  const showMiddleColumn = activeSection !== 'profile' && activeSection !== 'admin' && activeSection !== 'settings';

  return (
    <div className="bg-white dark:bg-[#080e1a] text-slate-900 dark:text-slate-200 font-display h-screen flex flex-col overflow-hidden">
      {/* Electron Title Bar — sadece masaüstü uygulamada görünür */}
      <TitleBar />

      {/* 3-Column Layout: Nav | List | Main - Edge to Edge */}
      <div className="flex flex-1 overflow-hidden">
        {/* Impersonate Banner */}
        <ImpersonateBanner />

        <div className="flex flex-1 overflow-hidden">
          {/* Column 1: Left Navigation */}
          <NavSidebar
            activeSection={activeSection}
            onSectionChange={handleSectionChange}
            isCollapsed={isNavCollapsed}
            onToggle={() => setIsNavCollapsed(c => !c)}
          />

          {/* Column 2: List / Section Sidebar */}
          {showMiddleColumn && (
            <Sidebar activeSection={activeSection} />
          )}

          {/* Column 3: Editor & Chat - Edge to Edge */}
          <main className="flex-1 flex flex-col min-w-0 bg-white dark:bg-[#080e1a] relative">
            <Header onSectionChange={handleSectionChange} />
            {/* Syncing / sync-failed şeritleri; çevrimdışı yatay banner artık Header göstergesinde */}
            <ConnectionMonitorBanner />
            <div className="flex-1 overflow-y-auto bg-white dark:bg-[#080e1a]">
              {children}
            </div>
          </main>
        </div>
      </div>

      {/* Global Floating Chat Widget */}
      <FloatingChatWidget />
    </div>
  );
};

export default Layout;
